<template>
  <v-container class="mt-16">
    <div class="pl pr">
      <v-card flat>
        <v-card-title class="d-flex">
          <h2>Invoices</h2>

          <v-spacer></v-spacer>
          <v-btn small @click="enable_paid_invoices_modal = true" class="mr-2"
            >Paid Invoices</v-btn
          >
          <v-btn small @click="print_unpaid_invoices"
            >Print Unpaid Invoices</v-btn
          >
          <add-invoice-card :is_invoice="1" />
          <v-btn
            color=""
            class=""
            icon
            x-large
            @click="refresh"
            :loading="loading"
            ><v-icon>mdi-refresh</v-icon></v-btn
          >
        </v-card-title>

        <v-card-text>
          <div>
            <v-text-field
              label="Search "
              prepend-icon="mdi-magnify"
              v-model="search"
            ></v-text-field>
            <v-data-table
              :items="all_invoices"
              :headers="headers"
              :search="search"
              :loading="loading"
            >
              <template v-slot:item.customer.customer_name="{ item }">
                <span
                  :class="item.customer.is_government == 1 ? 'blue--text' : ''"
                  >{{ item.customer.customer_name }}</span
                >
              </template>
              <template v-slot:item.chequeAmount="{ item }">
                <span v-if="item.customer.is_government">{{
                  getSixPercent(item.total_amount)
                }}</span>
                <span v-else>n/a</span>
              </template>
              <template v-slot:item.action="{ item }">
                <div class="d-flex">
                  <v-btn
                    icon
                    @click="enablePayablesModal(item)"
                    color="primary"
                    class=""
                    ><v-icon class="">mdi-logout-variant</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="user.access_level == 3 || user.access_level == 6"
                    @click="open_payment(item)"
                    color="yellow"
                    icon
                    ><v-icon>mdi-cash-multiple</v-icon></v-btn
                  >
                  <v-btn
                    @click="print_modal(item)"
                    small
                    icon
                    color="success"
                    class="mt-1"
                    ><v-icon>mdi-printer</v-icon></v-btn
                  >

                  <v-btn
                    v-if="user.access_level >= 6"
                    icon
                    @click="del_invoice(item)"
                    color="red"
                    class="mr-1"
                    :loading="loading"
                    ><v-icon class="mr-2">mdi-delete</v-icon></v-btn
                  >
                </div>
              </template>
              <template v-slot:item.balance="{ item }">
                <span>{{ item.balance.toLocaleString() }}</span>
              </template>
              <template v-slot:item.total_amount="{ item }">
                <span>{{ item.total_amount.toLocaleString() }}</span>
              </template>
              <template v-slot:item.invoice_status="{ item }">
                <span
                  :class="
                    item.invoice_status == 'Paid' ? 'green--text' : 'red--text'
                  "
                  >{{ item.invoice_status }}</span
                >
              </template>
              <template v-slot:item.is_invoice="{ item }">
                <v-chip color="blue" class="white--text" v-if="item.is_invoice"
                  >Invoice</v-chip
                >
                <v-chip color="red" class="white--text" v-else>Bill</v-chip>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <!-- lazy loaded -->
    <add-payment
      v-if="enable_add_payment_modal"
      :invoice="selected_invoice"
      @close="enable_add_payment_modal = false"
    />
    <print-modal-card
      v-if="show_print_modal"
      :item="selected_invoice"
      @close="show_print_modal = false"
    />
    <paid-invoices-modal
      v-if="enable_paid_invoices_modal"
      @close="enable_paid_invoices_modal = false"
    />
    <payables-modal
      v-if="enable_payables_modal"
      :invoice="selected_invoice"
      @close="enable_payables_modal = false"
    />
  </v-container>
</template>

<script>
// import { defineAsyncComponent } from "vue";
import { mapGetters, mapActions } from "vuex";
import AddInvoiceCard from "../components/Invoice/addInvoiceCard.vue";

export default {
  components: {
    AddInvoiceCard,
    payablesModal: () => import("../components/Payment/payablesModal.vue"),
    addPayment: () => import("../components/Payment/addPaymentModal.vue"),
    PrintModalCard: () => import("../components/Invoice/printModalCard.vue"),
    PaidInvoicesModal: () =>
      import("../components/Invoice/paidInvoicesModal.vue"),
  },
  data() {
    return {
      enable_payables_modal: false,
      enable_paid_invoices_modal: false,
      show_print_modal: false,
      selected_invoice: [],
      enable_add_payment_modal: false,
      ready: false,
      search: "",
      loading: false,
      headers: [
        { text: "Action", value: "action", width: "80" },
        { text: "ID", value: "id" },
        { text: "Invoice Code", value: "invoice_code" },
        { text: "Account Name", value: "customer.customer_name" },
        { text: "Invoice Date", value: "invoice_date" },
        { text: "Invoice Status", value: "invoice_status" },
        { text: "Balance", value: "balance" },
        { text: "Cheque Amount", value: "chequeAmount" },
        { text: "VAT", value: "vat" },
        { text: "Total Amount", value: "total_amount" },

        { text: "Type", value: "is_invoice" },
        { text: "Purpose", value: "purpose" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      default_server_url: "auth/default_server_url",
      all_invoices: "invoice/all_invoices",
      user: "auth/user",
    }),
  },
  methods: {
    getSixPercent(totalAmount) {
      //less 12%
      var vatableAmount = totalAmount / 1.12;
      var vatAmount = totalAmount - vatableAmount;
      var sixPercent = vatAmount / 2;
      var checkAmount = totalAmount - sixPercent;
      var rounded = Math.round(checkAmount);
      var formatted = rounded.toLocaleString(rounded);
      return formatted;
    },
    enablePayablesModal(invoice) {
      this.selected_invoice = invoice;
      this.enable_payables_modal = true;
      console.log("triggered");
    },
    print_modal(item) {
      this.show_print_modal = true;
      this.selected_invoice = item;
    },
    print_unpaid_invoices() {
      let url =
        this.default_server_url +
        "/print_unpaid_invoices/" +
        this.user.branch_id;
      window.open(url);
    },
    open_payment(item) {
      this.selected_invoice = item;
      this.enable_add_payment_modal = true;
    },
    async del_invoice(item) {
      this.loading = true;
      let y = window.confirm("Are you sure you want to delete this invoice?");
      if (y) {
        await this.delete_invoice(item);
        this.loading = false;
        alert("Successfully deleted an invoice");
      } else {
        this.loading = false;
      }
    },
    refresh() {
      this.loading = true;
      this.get_all_invoices().then(() => {
        this.loading = false;
      });

      return;
    },
    ...mapActions({
      get_all_invoices: "invoice/get_all_invoices",
      delete_invoice: "invoice/delete_invoice",
    }),
  },
  async created() {
    this.loading = true;
    if (this.all_invoices.length <= 0) {
      await this.get_all_invoices();
    }
    this.loading = false;
  },
};
</script>

<style></style>
